import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { head } from "lodash";
import(
  /* webpackChunkName: "order-builder-ite-power-level" */ "./itePowerLevel.scss"
);
import InsertLink from "@material-ui/icons/InsertLink";
import LinkOff from "@material-ui/icons/LinkOff";
import testModel from "../../../../assets/img/ModelTest.png";

const ITEPowerLevel = ({
  setITEPowerLevelForOrder,
  itePowerLevelRight,
  itePowerLevelLeft,
  activeRightITEPowerLevel,
  setActiveRightITEPowerLevel,
  activeLeftITEPowerLevel,
  setActiveLeftITEPowerLevel,
  leftSelected,
  rightSelected,
  iteModelLinked,
  selectedModelLeft,
  selectedModelRight,
  selectedPresetRight,
  selectedPresetLeft,
}) => {
  const [linked, setLinked] = useState(true);

  const [hasSetPresetLeft, setHasSetPresetLeft] = useState(false);
  const [hasSetPresetRight, setHasSetPresetRight] = useState(false);

  useEffect(() => {
    if (
      selectedPresetLeft !== "manual" &&
      selectedPresetLeft !== null &&
      selectedPresetLeft !== undefined
    ) {
      const hasPowerLevelPresetLeft = selectedPresetLeft.PresetValues.some(
        (preset) => preset.ValueType === "PowerLevel"
      );
      if (hasPowerLevelPresetLeft) {
        setHasSetPresetLeft(true);
        const powerLevelPresetLeft = selectedPresetLeft.PresetValues.find(
          (preset) => preset.ValueType === "PowerLevel"
        );
        const powerLevelFromList = itePowerLevelLeft.find(
          (s) => s.Code === powerLevelPresetLeft.OptionValue
        );
        setLeftActive(powerLevelFromList);
      } else {
        setHasSetPresetLeft(false);
      }
    } else {
      setHasSetPresetLeft(false);
    }
  }, [selectedPresetLeft, selectedModelLeft]);

  useEffect(() => {
    if (
      selectedPresetRight !== "manual" &&
      selectedPresetRight !== null &&
      selectedPresetRight !== undefined
    ) {
      const hasPowerLevelPresetRight = selectedPresetRight.PresetValues.some(
        (preset) => preset.ValueType === "PowerLevel"
      );
      if (hasPowerLevelPresetRight) {
        setHasSetPresetRight(true);
        const powerLevelPresetRight = selectedPresetRight.PresetValues.find(
          (preset) => preset.ValueType === "PowerLevel"
        );
        const powerLevelFromList = itePowerLevelRight.find(
          (s) => s.Code === powerLevelPresetRight.OptionValue
        );
        setRightActive(powerLevelFromList);
      } else {
        setHasSetPresetRight(false);
      }
    } else {
      setHasSetPresetRight(false);
    }
  }, [selectedPresetRight, selectedModelRight]);

  useEffect(() => {
    if (!hasSetPresetLeft || !hasSetPresetRight) {
      //Set initial active powerlevel using head method from lodash.
      // Grabs first item in an array but wont throw an error if the array is empty. Better than array[0]
      if (itePowerLevelRight) {
        const initalActive = head(itePowerLevelRight, {});
        setRightActive(initalActive);
      }
      if (itePowerLevelLeft) {
        const initalActive = head(itePowerLevelLeft, {});
        setLeftActive(initalActive);
      }
    }
  }, [itePowerLevelRight, itePowerLevelLeft, hasSetPresetLeft, hasSetPresetRight, selectedModelLeft, selectedModelRight]);

  useEffect(() => {
    if (activeRightITEPowerLevel || activeLeftITEPowerLevel) {
      const powerLevels = {
        right: activeRightITEPowerLevel,
        left: activeLeftITEPowerLevel,
      };
      // setITEPowerLevelForOrder(powerLevels);
    }
  }, [activeRightITEPowerLevel, activeLeftITEPowerLevel]);

  // Set power levels for order
  // Set other side if still linked
  const setRightActive = (powerLevel) => {
    setActiveRightITEPowerLevel(powerLevel);
    if (linked && iteModelLinked) {
      setActiveLeftITEPowerLevel(powerLevel);
    }
  };

  const setLeftActive = (powerLevel) => {
    setActiveLeftITEPowerLevel(powerLevel);
    if (linked && iteModelLinked) {
      setActiveRightITEPowerLevel(powerLevel);
    }
  };

  return (
    <div>
      {(itePowerLevelRight || itePowerLevelLeft) &&
        (rightSelected || leftSelected) && (
          <div className="ite-power-level-component-main-div order-builder-component">
            <Row className="order-builder-component-title">
              <Col xs={4}>
                <h2>Choose a power level</h2>
              </Col>
              <Col xs={8}>
                <Row>
                  <Col md={5}>
                    {rightSelected && (
                      <div className="text-right">
                        <h3>Right Ear</h3>
                      </div>
                    )}
                  </Col>
                  <Col md={2}>
                    {rightSelected && leftSelected && (
                      <div className="text-center link-div">
                        {linked && iteModelLinked ? (
                          <InsertLink
                            className="linked"
                            onClick={() => setLinked(false)}
                          />
                        ) : (
                          <LinkOff
                            onClick={() => setLinked(!linked)}
                            className="unlinked"
                          />
                        )}
                      </div>
                    )}
                  </Col>
                  <Col md={5}>
                    {leftSelected && (
                      <div>
                        <h3>Left Ear</h3>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    {rightSelected && (
                      <Row className="ite-power-level-row-right">
                        {itePowerLevelRight &&
                          itePowerLevelRight.map((powerLevel, index) => (
                            <Col key={index} xs={4}>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (hasSetPresetRight) return;
                                  setRightActive(powerLevel);
                                }}
                                style={{
                                  cursor: hasSetPresetRight ? "not-allowed" : "pointer",
                                  opacity: hasSetPresetRight ? 0.6 : 1
                                }}
                              >
                                <div
                                  className={`ite-power-level-box ${
                                    activeRightITEPowerLevel.Code ===
                                    powerLevel.Code
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <div className="ite-power-level-box-text">
                                    <p>{powerLevel.Name}</p>
                                  </div>
                                </div>
                              </a>
                            </Col>
                          ))}
                      </Row>
                    )}
                  </Col>
                  <Col md={6}>
                    {leftSelected && (
                      <Row className="ite-power-level-row-left left-side">
                        {itePowerLevelLeft &&
                          itePowerLevelLeft.map((powerLevel, index) => (
                            <Col key={index} xs={4}>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (hasSetPresetLeft) return;
                                  setLeftActive(powerLevel);
                                }}
                                style={{
                                  cursor: hasSetPresetLeft ? "not-allowed" : "pointer",
                                  opacity: hasSetPresetLeft ? 0.6 : 1
                                }}
                              >
                                <div
                                  className={`ite-power-level-box ${
                                    activeLeftITEPowerLevel &&
                                    activeLeftITEPowerLevel.Code ===
                                      powerLevel.Code
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <div className="ite-power-level-box-text">
                                    <p>{powerLevel.Name}</p>
                                  </div>
                                </div>
                              </a>
                            </Col>
                          ))}
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
    </div>
  );
};

export default ITEPowerLevel;
